export default function HowToUse() {
  const hairSteps = [
    'Take henna powder in a bowl',
    'Add water and make smooth paste',
    'Keep aside for few hours',
    'Apply evenly on hair',
    'Leave for 1–2 hours',
    'Rinse with plain water'
  ];

  const mehndiSteps = [
    'Take henna powder',
    'Mix with water to make paste',
    'Fill in cone',
    'Apply design on hands',
    'Let it dry and remove'
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            How to Use
          </h2>
          <div className="w-24 h-1 bg-orange-500 mx-auto mb-6"></div>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
            Simple steps for perfect results every time
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Hair Use */}
          <div className="bg-gradient-to-br from-green-50 to-white rounded-2xl p-8 shadow-lg">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center mr-4">
                <i className="ri-scissors-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">For Hair Use</h3>
            </div>
            <div className="space-y-4">
              {hairSteps.map((step, index) => (
                <div key={index} className="flex items-start">
                  <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0 mt-1">
                    <span className="text-white font-bold text-sm">{index + 1}</span>
                  </div>
                  <p className="text-base text-gray-700 pt-1">{step}</p>
                </div>
              ))}
            </div>
            <div className="mt-8 w-full h-64 rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Woman%20applying%20natural%20henna%20paste%20on%20long%20dark%20hair%20for%20coloring%20and%20conditioning%2C%20hair%20care%20treatment%20process%2C%20beautiful%20healthy%20hair%2C%20natural%20beauty%20routine%2C%20step%20by%20step%20application%2C%20professional%20beauty%20photography%2C%20simple%20clean%20white%20background&width=800&height=600&seq=hairuse1&orientation=landscape"
                alt="Hair Use"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Mehndi Use */}
          <div className="bg-gradient-to-br from-orange-50 to-white rounded-2xl p-8 shadow-lg">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center mr-4">
                <i className="ri-hand-heart-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">For Mehndi Use</h3>
            </div>
            <div className="space-y-4">
              {mehndiSteps.map((step, index) => (
                <div key={index} className="flex items-start">
                  <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0 mt-1">
                    <span className="text-white font-bold text-sm">{index + 1}</span>
                  </div>
                  <p className="text-base text-gray-700 pt-1">{step}</p>
                </div>
              ))}
            </div>
            <div className="mt-8 w-full h-64 rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Mehndi%20artist%20applying%20intricate%20traditional%20henna%20design%20on%20bride%20hands%20using%20cone%2C%20beautiful%20detailed%20patterns%2C%20cultural%20wedding%20ritual%2C%20artistic%20mehendi%20application%2C%20elegant%20hand%20decoration%2C%20professional%20mehndi%20art%2C%20simple%20clean%20white%20background&width=800&height=600&seq=mehndiuse1&orientation=landscape"
                alt="Mehndi Use"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}